import { useContext } from "react";
// import { FormContextMA } from "../form-context";
import { DataField, Divider, H2, H3, P, Section } from "./common-components";
import { formatToYYYY_MMM_DD } from "../../../helpers/functions";
import { AllergicRhinitisDocTypes, MedicationReviewDocTypes } from "../../patient/clinical-services/service-steps/documentation/data";

export const ServiceInfo = ({ referral, isReferral
  , formType,
    clinicalServiceName,
    patient,
    preAssessment,
    startDateTime,
    isInterventionForm = false
  }) => {

  const minorAilmentName = {
    allergicRhinitis: "ALLERGIC RHINITIS",
  }[clinicalServiceName];

  const formattedDesignation =
    referral && typeof referral.designation === "string" && referral.designation.length
      ? referral.designation.charAt(0).toUpperCase() + referral.designation.slice(1)
      : referral?.designation;

  return (
    <Section formType = {formType}>
      {isInterventionForm ? (
        <div className="flex flex-row justify-end">
          <DataField
            label="Service Date:"
            value={formatToYYYY_MMM_DD(startDateTime)}
          />
        </div>
      ) : (
        ([AllergicRhinitisDocTypes.InitialAssessment].includes(formType) 
        || [MedicationReviewDocTypes.PharmacistWorksheet].includes(formType)) && (
          <div className="flex flex-row justify-between">

            {([AllergicRhinitisDocTypes.InitialAssessment].includes(formType)) && (
              <H2>
                Minor Ailment Prescribing Service: {minorAilmentName} - TREATMENT
              </H2>
            )}
            
            {([MedicationReviewDocTypes.PharmacistWorksheet].includes(formType)) && (
              <H2>
                Pharmacists Worksheet - Annual Medication Review
              </H2>
            )}
            <DataField
              label="Service Date:"
              value={formatToYYYY_MMM_DD(startDateTime)}
            />
          </div>
        )
      )}
      {[
        AllergicRhinitisDocTypes.PhysicianReferralForm,
        AllergicRhinitisDocTypes.PrescribingRecord,
        AllergicRhinitisDocTypes.PrescribingRecordWithReferral,
      ].includes(formType) ? (
        <div className="space-y-[0.104167in]">
          <div className="space-y-[0.166667in]">
            <div className="flex flex-row justify-between gap-[0.0416667in]">
              <H3 className="text-[16px]">Minor Ailment Prescribing Service</H3>
              <P className="text-[16px]">Service Date: {formatToYYYY_MMM_DD(startDateTime)}</P>
            </div>
            {referral ? (
              <DataField
                label={`To: ${referral?.referralType + " /" + formattedDesignation}`}
              />
            ) : (
              <DataField
                label={`To: ${referral?.referralType + " /" + formattedDesignation}`}
              />
            )}
            <div className="space-y-[0.0833333in]">
              <div className="space-y-1">
                <DataField
                  value={`After an assessment with the patient for: ${minorAilmentName}`}
                />
                <DataField
                  label={
                    isReferral
                      ? `A REFERRAL was suggested for the patient to seek medical attention for further evaluation.`
                      : "A PRESCRIPTION was provided, with reasons included below. "
                  }
                />
                <DataField
                  label={`This is for your information to keep your records for this patient up to date.`}
                />
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </Section>
  );
};
